import { default as hybridConfig } from "lib/HybridConfig";
import Model from "models/Model";
import Stereotypes from "models/Stereotypes";

class DataQualityReport extends Model {
    constructor(...args) {
        super(...args);
        this.initialize = this.initialize.bind(this);
        this.resetPagination = this.resetPagination.bind(this);
        this.getReportTypeKey = this.getReportTypeKey.bind(this);
        this.getValidationTypeCode = this.getValidationTypeCode.bind(this);
    }

    defaults() {
        const reportTypeOptionsCollection = new Backbone.Collection([
            {name: "Summary Quality Report", key: "s"},
            {name: "Detail Quality Report", key: "d"},
            {name: "All Records Report", key: "a"},
        ]);

        const validationTypeOptionCollection = new Backbone.Collection([
            {
                template: (illegalLabel="Illegal") =>
                    `${illegalLabel} Values or Warning`,
                key: "iw",
                code: "illegal,warning",
            },
            {
                template: (illegalLabel="Illegal") =>
                    `${illegalLabel} Values`,
                key: "i",
                code: "illegal"
            },
            {
                template: (illegalLabel="Illegal") =>
                    "Warnings",
                key: "w",
                code: "warning"
            },
        ]);

        return {
            stereotypes: new Stereotypes(),
            pageSize: hybridConfig.get("dqr.defaultPageSize", 500),
            reportType: reportTypeOptionsCollection.first(),
            reportTypeOptionsCollection,

            searchParameters: new Backbone.Collection(),
            searchResults: new Backbone.Collection(),
            sorts: new Backbone.Model(),

            validationType: validationTypeOptionCollection.first(),
            validationTypeOptionCollection,

            owners: [""],

            // previously anonymous attributes
            page: null,
            serverSearchResults: null,
            stereotype: null,
            searchQuery: null,
        };
    }

    initialize() {
        const reportTypeOptionsCollection = this.get(
            "reportTypeOptionsCollection");
        this.listenTo(
            reportTypeOptionsCollection,
            "selected",
            model => this.set("reportType", model),
        );

        const validationTypeOptionCollection = this.get(
            "validationTypeOptionCollection");
        this.listenTo(
            validationTypeOptionCollection,
            "selected",
            model => this.set("validationType", model),
        );

        this.numberOfPagesToPreload = hybridConfig.get(
            "dqr.numberOfPagesToPreload",
            10,
        );
        this.resetPagination();
    }

    resetPagination() {
        this.set("page", 1);
        const pageSize = this.get("pageSize");

        // This roughly emulates what the server returns from a search request.
        const resultsModel = new Backbone.Model({
            results: new Backbone.Collection(),
            pageSize: pageSize * this.numberOfPagesToPreload,
            page: 1,
        });
        this.set("serverSearchResults", resultsModel);
    }

    getReportTypeKey() {
        return this.get("reportType").get("key");
    }

    getValidationTypeCode() {
        return this.get("validationType").get("code");
    }
}

export default DataQualityReport;



// WEBPACK FOOTER //
// ./app/models/DataQualityReport.js